<template>
  <div class="product" ref="product">
    <ul>
      <li>
        <img class="everyImg" :data-src="this.imageDict['0']" src="@/assets/images/pixel.png" />
      </li>
      <div ref="time_wrap" class="time_wrap">
        <div class="lunbo">
          <!-- 用户领取滚动 -->
          <SwiperView></SwiperView>
        </div>
        <div class="timer">
          <!-- 定时器组件 -->
          <TimeViewVue></TimeViewVue>
        </div>
      </div>
      <!-- 引用表单组件需传入  落地页名缩写  -->
      <div class="tab_wrapper">
        <div>
          <div class="tab">
            <div class="tab-item" :style="activeTab == index ? activeBgc : ''" @click="changeTab(index)"
              v-for="(item, index) in this.tabData" :key="index">
              {{ item.name }}
              <span class="tips">new</span>
              <span class="line" v-if="activeTab == index"></span>
            </div>
          </div>
          <div class='tab-body'>
            <form-view @showData="showSuccess" :pageName="'qg'" :planId="this.planId"></form-view>
          </div>
        </div>
      </div>
      <li>
        <img class="everyImg" :data-src="this.imageDict['1']" src="@/assets/images/pixel.png" />
      </li>
      <div class="hot">
        <div><img src="@/assets/images/0.png" alt="" /></div>
        <!-- 热门推荐滚动 -->
        <div class="hot_swiper">
          <hot-swiper></hot-swiper>
        </div>
      </div>
      <li>
        <img class="everyImg" :data-src="this.imageDict['2']" src="@/assets/images/pixel.png" />
      </li>
      <li>
        <img class="everyImg" :data-src="this.imageDict['3']" src="@/assets/images/pixel.png" />
      </li>
      <li>
        <img class="everyImg" :data-src="this.imageDict['4']" src="@/assets/images/pixel.png" />
      </li>
    </ul>
    <!-- 领取成功时的弹框图 -->
    <van-popup v-model="show" class="successImg">
      <div class="close" @click="closeImg"></div>
      <img v-lazy="this.successImg" alt="" :key="this.successImg" />
    </van-popup>

  </div>
</template>


<script>
import TimeViewVue from "@/components/compent/TimeView.vue";
import SwiperView from "../components/compent/SwiperView.vue";
import HotSwiper from "@/components/compent/HotSwiper.vue";
import FormView from "@/components/group/FormView.vue";
import utils from "@/assets/js/utils.js";
import { nextTick } from 'vue';

export default {
  components: {
    TimeViewVue,
    SwiperView,
    HotSwiper,
    FormView,
  },
  data() {
    return {
      show: false,
      imageDict: {},
      successImg: null,

      tabData: [],
      planId: null,
      activeTab: 1,

      activeBgc: {
        backgroundColor: "",
        scale: 1.2,
        color: " #fff",
        borderTopLeftRadius: ".15rem",
        "border-top-right-radius": ".15rem",
        "box-shadow": "rgba(0, 0, 0, 0.3) -2px -2px 2px",
      }
    };
  },
  methods: {
    // 显示成功领取框
    showSuccess(val) {
      this.show = val;
    },
    // 关闭成功领取框
    closeImg() {
      this.show = false;
    },
    getUrlParams(url) {
      let urlStr = url.split("?")[1];
      const urlSearchParams = new URLSearchParams(urlStr);
      const result = Object.fromEntries(urlSearchParams.entries());
      return result;
    },
    changeTab(index) {
      this.activeTab = index;
      let urlParams = this.getUrlParams(this.tabData[index].linkUrl);
      this.planId = urlParams["planId"];
      let domain =
        process.env.NODE_ENV === "production"
          ? ""
          : "http://h5.huizoom.cn:1007";
      let imageDict = {};
      for (const key in this.tabData[index].product?.imageSrc) {
        imageDict[key] =
          domain + "/image_service" + this.tabData[index].product.imageSrc[key];
      }
      this.successImg = imageDict["5"];
      this.imageDict = imageDict;
      //图片懒加载
      utils.lazyLoad(".everyImg");

      let bgc = urlParams["bgc"];
      if (!bgc) {
        bgc = "2f2d2e";
      }
      this.$nextTick(() => {
        this.$refs.product.style.backgroundColor = "#" + bgc;
        this.activeBgc.backgroundColor = "#" + bgc
      })

    },
  },
  mounted() {
    let appId = utils.getQueryVariable("appId");
    if (!appId) {
      this.$router.push({
        path: "/404",
      });
    }
    this.$axios
      .get(`/applet/web/productList/${appId}`)
      .then((res) => {
        let { code, data } = res.data;
        this.tabData = data;
        if (data.length < 2) {
          this.activeTab = 0;
        }
        this.changeTab(this.activeTab);
      })
      .catch((err) => {
        console.log(err);
      });

    this.$refs.time_wrap.style.display = "none";
    // 调用方法
    let track_id = utils.getQueryVariable("track_id");
    let convertId = utils.getQueryVariable("convertId");
    if (track_id) {
      // 去除顶部轮播 和 加页脚
      this.$refs.time_wrap.style.display = "none";
      this.$refs.footer.style.display = "block";
    } else if (convertId) {
      // 添加页脚
      this.$refs.footer.style.display = "block";
    }

    // 禁止浏览器缩放
    utils.onload();
  },
};
</script>

<style lang="scss" scoped>
.product {
  padding-bottom: 0.7rem;
  font-family: -apple-system-font, Helvetica Neue, sans-serif;

  li {
    width: 100%;
  }

  img {
    width: 100%;
  }

  .time_wrap {
    width: 100%;
    height: 0.45rem;
    padding: 0.2rem 0;
    color: #fff;
    background-color: #f00;
    border-radius: 0.3rem;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.23rem !important;

    .lunbo {
      width: 82%;
      height: 0.3rem;
      overflow: hidden;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .timer {
      width: 4rem;
      height: 0.3rem;
      line-height: 0.3rem;
      margin-left: -0.2rem;
    }
  }

  .hot {
    padding: 0 0.4rem;
  }

  .van-popup {
    background-color: transparent;
  }

  .successImg img {
    display: block;
    width: 7rem;
    // height: 7rem;
  }

  .close {
    position: absolute;
    bottom: 0;
    width: 2rem;
    height: 1rem;
    left: 50%;
    border-radius: 7%;
    opacity: 0;
    transform: translateX(-50%);
  }

  .footer {
    width: 100%;
    height: 1rem;
    padding-bottom: 1.8rem;
    // background-color: #1B1C16;
    text-align: center;

    p {
      margin: 0.1rem 0;
      color: #f1f2f4;
      letter-spacing: 0.02rem;
    }
  }

  .tips {
    background-color: #fce48b;
    padding: 0 0.1rem;
    position: absolute;
    z-index: 1000;
    line-height: normal;
    top: -.2rem;
    right: .1rem;
    color: #000;
    font-size: 12px;
    border-top-left-radius: 0.2rem;
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
    animation: scaleDraw 5s ease-in-out infinite;
    -webkit-animation: scaleDraw 3s ease-in-out infinite;
  }

  @keyframes scaleDraw {
    0% {
      transform: scale(1);
    }

    25% {
      transform: scale(1.2);
    }

    50% {
      transform: scale(1);
    }

    75% {
      transform: scale(1.2);
    }
  }

  .line {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 15px;
    height: 3px;
    background-color: #fff;
    border-radius: 2px;
  }

  .tab {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: .8rem;
    line-height: .8rem;
    background-color: rgba(0, 0, 0, 0.35);
    color: #fff;

    .tab-item {
      height: 100%;
      width: 2rem;
      text-align: center;
      position: relative;
    }
  }

  .tab-body {
    margin-top: .2rem;
  }
}
</style>
